const headCells = [
  {
    id: 'id',
    numeric: false,
    disablePadding: true,
    label: 'Номер',
    width: '116px',
  },
  {
    id: 'color',
    numeric: false,
    disablePadding: true,
    label: '',
    width: '30px',
  },
  {
    id: 'loading',
    numeric: true,
    disablePadding: false,
    label: 'Погрузка',
    width: '50px',
  },
  {
    id: 'unloading',
    numeric: true,
    disablePadding: false,
    label: 'Выгрузка',
    width: '50px',
  },
  {
    id: 'addressLoading',
    numeric: false,
    disablePadding: false,
    label: 'Адрес погрузки',
    width: '162px',
  },
  {
    id: 'addressUnloading',
    numeric: false,
    disablePadding: false,
    label: 'Адрес выгрузки',
    width: '162px',
  },
  {
    id: 'weight',
    numeric: true,
    disablePadding: false,
    label: 'Вес/Объем',
    width: '142px',
  },
  {
    id: 'petrolType',
    numeric: true,
    disablePadding: false,
    label: 'Тип топлива',
    width: '100px',
  },
  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    label: 'Статус',
    width: '116px',
  },
  {
    id: 'func',
    numeric: false,
    disablePadding: false,
    label: '',
    width: '30px',
  },
];

export default headCells;
